import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { Media } from "@omni/types/api/shared/bff/media.model";
import { ProductImageRenditions } from "@omni/types/components/product/productImageRenditions.type";

import { ProductImageWrapper } from "@/components/Product/ProductImage/productImage.component";

type Props = {
    title: string | undefined;
    medias?: null | Array<Media>;
    rendition?: ProductImageRendition;
    renditions?: ProductImageRenditions;
    isEcoChequesAccepted: boolean;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImageContainer = ({
    title,
    medias,
    renditions,
    isEcoChequesAccepted,
    className,
    lazyLoad = false,
    parentFit = false
}: Props) => {
    if (!medias || medias.length === 0) {
        return null;
    }

    return (
        <ProductImageWrapper
            title={title}
            medias={medias}
            renditions={renditions}
            isEcoChequesAccepted={isEcoChequesAccepted}
            className={className}
            lazyLoad={lazyLoad}
            parentFit={parentFit}
        />
    );
};

export { ProductImageContainer };
